import React, {useContext, useEffect, useState} from 'react';
import ReactModal from 'react-modal';
import defaultImage from "./images/airplane.png";
import axios from "axios";
import Image from "./Image";
import {UserContext} from "./UserContext";
import {getBearerToken, getServerUrl} from "./utils/utils";
import ViewTrip from "./ViewTrip";
import CircularProgress from '@mui/material/CircularProgress/';

function TripModal({location, fullscreen, endpoint, onClose}) {
    const {user} = useContext(UserContext)
    const [selectedTripId, setSelectedTripId] = useState(null)
    const [images, setImages] = useState([])
    const [allImages, setAllImages] = useState([])
    const [trips, setTrips] = useState([])
    const [isOpen, setIsOpen] = useState(false)
    const [openViewTripModal, setOpenViewTripModal] = useState(false)
    const [viewTripId, setViewTripId] = useState(null)
    const [shouldRetrieveImages, setShouldRetrieveImages] = useState(false)
    const [retrievingImages, setRetrievingImages] = useState(false)

    const isScrollAtBottom = (element) => {
        const num = Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop)
        return num <= 10;
    }

    const handleScroll = () => {
        const myDiv = document.querySelector('.fullscreen-trip-images-div');
        if (isScrollAtBottom(myDiv)) {
            if (!shouldRetrieveImages && !retrievingImages && (allImages?.length !== images.length && allImages?.length > 12)) {
                setShouldRetrieveImages(true)
            }
        }
    }


    useEffect(() => {
        const retrieveImages = setTimeout(() => {
            if (shouldRetrieveImages) {
                setShouldRetrieveImages(false)
                if ((allImages?.length !== images.length && allImages?.length > 12)){
                    retrieveImagesInBatches(selectedTripId, images.length)
                }
            }
        }, 250)
        return () => clearTimeout(retrieveImages)
    }, [allImages, images, shouldRetrieveImages])

    const fetchTripsByLocation = async () => {
        axios.get(`${getServerUrl()}${endpoint}${location}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setTrips(response.data?.trips || response.data)
                if (response.data?.trips?.length > 0) {
                    setSelectedTripId(response.data.trips[0].id)
                } else if (response.data?.length > 0) {
                    setSelectedTripId(response.data[0].id)
                }
                if (!isOpen) {
                    setIsOpen(true)
                }
            })
    }

    useEffect(() => {
        if (location && fullscreen) {
            fetchTripsByLocation()
        }
    }, [location])

    useEffect(() => {
        if (selectedTripId && isOpen) {
            retrieveImagesInBatches(selectedTripId, 0)
        }
    }, [selectedTripId, isOpen])

    const retrieveImagesInBatches = async (selectedTripId, startIndex) => {
        setRetrievingImages(true)
        axios.get(`${getServerUrl()}/trip/${selectedTripId}/images?loadCoverImage=true&shortenVideo=true&loadAsBatch=true&batchLoadIndex=${startIndex}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setRetrievingImages(false)
                if (startIndex === 0) {
                    setAllImages(response.data)
                }
                const newImages = response.data.slice(0, response.data.length > 12 ? 12 : response.data.length)
                if (startIndex === 0) {
                    setImages(newImages)
                } else {
                    setImages(currentImages => {
                        const updatedCurrentImages = [...currentImages]
                        updatedCurrentImages.push(...newImages)
                        return updatedCurrentImages
                    })


                }
            })
    }


    const locationTrips = trips ? trips : []

    const tripList = locationTrips.map(trip => (
        <div
            className="trip-game-info-container"
            style={{background: selectedTripId === trip.id && trips?.length > 1 ? 'lightgray' : 'white'}}
            onClick={() => {
                setSelectedTripId(trip.id)
                const imagesWindow = document.getElementsByClassName("fullscreen-trip-images-div")?.[0]
                imagesWindow?.scrollTo({top: 0, behavior: 'smooth'});
            }}
        >
            <div className="trip-game-info">
                <div className="trip-profile-image-modal">
                    <img src={trip?.trip_profile_image ? trip?.trip_profile_image : defaultImage}/>
                </div>
                <div style={{width: '15vw'}}>
                    <h2>{trip?.name}</h2>
                    <h5>{`${trip.startDate.split(" ")[0]} - ${trip.endDate.split(" ")[0]}`}</h5>
                    <button onClick={() => {
                        setViewTripId(trip?.id)
                        setOpenViewTripModal(true)
                    }}>View Trip
                    </button>
                </div>

            </div>
        </div>
    ))

    const imageList = images.filter(image => {
        return image.image_location || image.video_location
    }).map(image => {
        return <Image imageFile={image} onClick={() => {
        }} imageIdsForNewActivity={[]}
                      key={image.id} showVideoCoverImage={true}/>
    })

    return (
        <ReactModal isOpen={isOpen} className="fullscreen-view-trip-modal trip-modal-container">
            <div className="view-team-modal-div" style={trips?.length > 3 ? {height: '90vh'} : {}}>
                <button
                    className="team-modal-button"
                    onClick={() => {
                        setImages([])
                        setSelectedTripId(null)
                        setIsOpen(false)
                        if (onClose){
                            onClose()
                        }
                    }}
                >close
                </button>
                <h1 className="team-modal-header">{location}</h1>
                {tripList}
            </div>
            <br />
            <div className="fullscreen-trip-images-div" onScroll={() => handleScroll()}>
                {imageList}
                {shouldRetrieveImages && (
                    <div className="circular-progress-div">
                        <div className="circular-progress-images">
                            <CircularProgress size={35}/>
                        </div>
                    </div>
                )}
            </div>
            <ViewTrip
                open={openViewTripModal}
                selectedTripId={viewTripId}
                onClose={() => {
                    setOpenViewTripModal(false)
                    setViewTripId(null)
                }}
                onTripUpdate={() => {
                }}
            />
        </ReactModal>
    )
}

export default TripModal;